import { values } from './enums'

const _enum = {
  InternalApp: 0,
  ReportApp: 1
}

export const applicationTypes = {
  enumName: 'ApplicationTypes',
  enum: _enum,
  values: values(_enum)
}



// WEBPACK FOOTER //
// ./src/enums/ApplicationTypes.js